module.exports = __webpack_public_path__ + "static/img/4-1.8029cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4-1.jpg
// module id = DhWp
// module chunks = 0